<template>
  <v-container
    v-bind="{ [`grid-list-sm`]: true }"
    fluid
    fill-height
    class="xs-only-px-0 pa-2"
  >
    <v-layout>
      <v-flex xs12>
        <v-card
          height="100%"
          class="display-flex column"
        >
          <v-card-title class="headline">
            Find a Lawyer
          </v-card-title>

          <div
            v-if="lawyersLoading"
            class="fill-width flex-flex-auto d-flex align-center justify-center o-hidden"
          >
            <div class="display-flex column align-center">
              <v-progress-circular
                :indeterminate="true"
                color="primary"
              /><br>Loading expert lawyers...
            </div>
          </div>

          <div
            v-else
            class="pt-0"
          >
            <v-layout
              row
              wrap
            >
              <v-flex
                v-for="user in lawyersSorted"
                :key="user['.key']"
                xxs12
                xs6
                sm4
                md3
                lg3
                xl2
              >
                <!-- <profile-card :user="user" :context="'findalawyer'" /> -->
                <profile-card
                  :profile-user="user"
                  :show-bio="true"
                  :show-bio-partial="true"
                />
              </v-flex>
            </v-layout>
          </div>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>

import ProfileCard from '@/components/ProfileCard'
import { fsdb } from '../firebase'
import orderBy from 'lodash/orderBy'
const _ = { orderBy }

export default {
  name: 'FindALawyer',
  components: { ProfileCard },
  data: () => ({
    lawyers: [],
    lawyersLoading: true
  }),
  computed: {
    lawyersFiltered() {
      if (this.lawyersLoading) { return [] }
      if (this.lawyers.length === 0) { return [] }

      return this.lawyers.filter(lawyer => lawyer.areas && Object.keys(lawyer.areas).length)
    },
    lawyersSorted() {
      if (this.lawyersFiltered.length === 0) { return [] }
      return _.orderBy(this.lawyersFiltered, ['name'], ['asc'])
    }
  },
  beforeCreate() {
    this.dispatchActions(['get_appUser'])

    this.mapStates(['user', 'appUser'])
    this.mapGetters(['isIndividual', 'usersById'])
  },
  async created() {
    await this.$binding('lawyers', fsdb.collection('users')
      .where('accountType', '==', 'lawyer')
      .where('active', '==', true))
    this.lawyersLoading = false
  }
}

</script>
